import React, { memo, useMemo, useState, useCallback } from "react";
import { ModeContext } from ".";
import { MODES } from "../../conf";
import useData from "../../hooks/useData";
import useMessage, { MESSAGE_TYPES } from "../../hooks/useMessage";

const ModeManager = memo(({ children }) => {
	const { initialMode, publisher_details } = useData();

	const [mode, setMode] = useState(initialMode);

	const inModal = useMemo(() => mode === MODES.MODAL, [mode]);

	// explicitly disabling PPE in modal
	const inPPE = useMemo(
		() => publisher_details?.post_purchase && mode !== MODES.INLINE,
		[mode, publisher_details]
	);

	const isInline = useMemo(() => mode === MODES.INLINE, [mode]);

	const isCollapsed = useMemo(
		() =>
			publisher_details?.post_purchase &&
			mode === MODES.FULLSCREEN_COLLAPSED,
		[mode, publisher_details]
	);

	const handleModeChange = useCallback(({ mode }) => {
		setMode(mode);
	}, []);

	useMessage(MESSAGE_TYPES.UPDATE_MODE, handleModeChange);

	return (
		<ModeContext.Provider
			value={{
				mode,
				setMode,
				inPPE,
				isInline,
				inModal,
				isCollapsed,
			}}
		>
			{children}
		</ModeContext.Provider>
	);
});

export default ModeManager;
